// Centralized Cytoscape stylesheet for GraphCyTo.
// Phase 1 refactor: extracted verbatim from GraphCyTo.vue to avoid behavioral changes.

import TOKENS from './tokens'

export default [
    {
        selector: 'node',
        style: {
            'text-valign': 'center',
            'text-halign': 'center',
            'background-color': 'data(bgColor)',
            'border-width': 'data(stroke)',
            'border-color': 'data(borderColor)',
            color: 'data(textColor)',
            height: '70px',
            shape: 'round-rectangle',
            content: 'data(content)',
            'text-wrap': 'wrap',
            'font-family': 'Open Sans, sans-serif',
            'font-size': '18px',
            'font-weight': 500,
            'line-height': '0.75em',
        },
    },
    {
        selector: 'node.is-grouped',
        style: {
            'background-color': TOKENS.node.groupedBg,
            'border-style': 'double',
        },
    },
    {
        selector: 'node.is-loop',
        style: {
            'border-color': TOKENS.node.loopBorder,
        },
    },
    {
        selector: 'edge.normal',
        style: {
            'curve-style': 'bezier',
            'control-point-distance': 120,
            'text-outline-color': '#f00',
            color: '#000',
            'text-background-padding': 6,
            width: 'data(strokeWidth)',
            'target-arrow-shape': 'triangle',
            'line-color': 'data(lineColor)',
            'target-arrow-color': 'data(lineColor)',
            label: 'data(label)',
            'font-family': 'Open Sans, sans-serif',
            'text-wrap': 'wrap',
            'text-max-width': 'none',
            'text-justification': 'center',
            'font-size': '18px',
            'font-weight': '500',
            'text-background-color': TOKENS.edge.normalTextBg,
            'text-background-opacity': 1,
            'text-border-color': TOKENS.edge.normalTextBorder,
            'text-border-width': 1,
            'text-border-opacity': 1,
            'text-background-shape': 'roundrectangle',
        },
    },
    {
        selector: 'edge.start',
        style: {
            'curve-style': 'bezier',
            'control-point-distance': 120,
            'line-style': 'dotted',
            'line-color': TOKENS.edge.startLine,
            'target-arrow-color': TOKENS.edge.startLine,
            'target-arrow-shape': 'triangle',
            'text-opacity': 0,
            width: 4,
        },
    },
    {
        selector: 'edge.end',
        style: {
            'curve-style': 'bezier',
            'control-point-distance': 120,
            'line-style': 'dotted',
            'line-color': TOKENS.edge.endLine,
            'target-arrow-color': TOKENS.edge.endLine,
            'target-arrow-shape': 'triangle',
            'text-opacity': 0,
            width: 4,
        },
    },
    {
        selector: 'edge.is-loop',
        style: {
            'line-color': TOKENS.edge.loopLine,
            'target-arrow-color': TOKENS.edge.loopLine,
        },
    },
    {
        selector: 'edge:loop',
        style: {
            'curve-style': 'bezier',
            'loop-direction': '90deg',
            'loop-sweep': '20deg',
            'target-arrow-shape': 'triangle',
        },
    },
]
